// components/ui/VerdictTrio.tsx
// Three-column verdict at the top of the report.
// The IHT cell is wider, tinted, and typographically dominant.

import React from 'react';

interface VerdictCell {
    label: string;
    headline: string;
    subtext: string;
}

interface VerdictTrioProps {
    probate: VerdictCell;
    filing: VerdictCell;
    iht: VerdictCell;
}

export function VerdictTrio({ probate, filing, iht }: VerdictTrioProps) {
    return (
        <div className="verdict-trio grid grid-cols-[1fr_1fr_1.15fr] border-t border-b border-[#E8E4DB] mb-10 items-stretch">
            <Cell {...probate} position="left" />
            <Cell {...filing} position="middle" />
            <Cell {...iht} position="right-emphasised" />
        </div>
    );
}

function Cell({
    label, headline, subtext, position,
}: VerdictCell & { position: 'left' | 'middle' | 'right-emphasised' }) {
    const isEmph = position === 'right-emphasised';
    return (
        <div
            className={`
                ${isEmph ? 'cell-emphasised' : ''}
                ${position === 'left' ? '' : 'border-l border-[#E8E4DB]'}
                ${isEmph ? 'bg-[#EEF0FA] p-[26px_24px]' : 'py-[22px] pl-6 pr-6'}
                ${position === 'left' ? 'pl-0 pr-6 py-[22px]' : ''}
            `}
        >
            <div className={`
                text-[10px] tracking-[0.18em] uppercase mb-2.5
                ${isEmph ? 'text-[#3730A3] font-semibold' : 'text-[#6B6762]'}
            `}>
                {label}
            </div>
            <div
                className={`headline ${
                    isEmph
                        ? 'font-serif text-[38px] font-medium tracking-[-0.02em] text-[#3730A3] leading-none'
                        : 'font-serif text-[22px] tracking-[-0.01em] text-[#1A1A1A] leading-[1.15]'
                }`}
            >
                {headline}
            </div>
            <div className={`text-[12px] text-[#6B6762] leading-relaxed ${isEmph ? 'mt-3' : 'mt-2'}`}>
                {subtext}
            </div>
        </div>
    );
}
